import { useEffect } from "react";


function encodeWAV(audioBuffer) {
    const numChannels = audioBuffer.numberOfChannels;
    const sampleRate = audioBuffer.sampleRate;
    const samples = audioBuffer.getChannelData(0);
    const length = samples.length;

    const buffer = new ArrayBuffer(44 + length * 2);
    const view = new DataView(buffer);

    function writeString(offset, str) {
        for (let i = 0; i < str.length; i++) {
            view.setUint8(offset + i, str.charCodeAt(i));
        }
    }

    writeString(0, "RIFF");
    view.setUint32(4, 36 + length * 2, true);
    writeString(8, "WAVE");
    writeString(12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, numChannels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * numChannels * 2, true);
    view.setUint16(32, numChannels * 2, true);
    view.setUint16(34, 16, true);
    writeString(36, "data");
    view.setUint32(40, length * 2, true);

    let offset = 44;
    for (let i = 0; i < length; i++, offset += 2) {
        let s = Math.max(-1, Math.min(1, samples[i]));
        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }

    return new Blob([buffer], { type: "audio/wav" });
}


async function cutTo15Seconds(file) {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();

    const arrayBuffer = await file.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

    const maxDuration = 15;
    const duration = Math.min(maxDuration, audioBuffer.duration);

    const sampleRate = audioBuffer.sampleRate;
    const frameCount = Math.floor(duration * sampleRate);

    const newBuffer = audioContext.createBuffer(
        audioBuffer.numberOfChannels,
        frameCount,
        sampleRate
    );

    for (let ch = 0; ch < audioBuffer.numberOfChannels; ch++) {
        const oldData = audioBuffer.getChannelData(ch);
        const newData = newBuffer.getChannelData(ch);
        newData.set(oldData.subarray(0, frameCount));
    }

    return encodeWAV(newBuffer);
}



export default function AudioTrimmer({ file, onComplete }) {
    
    useEffect(() => {
        if (!file || !Array.isArray(file)) return;
        
  
        const process = async () => {
            try {
                console.log("Upload clicked");
                const trimmed = await cutTo15Seconds(file);

                console.log("trim complete");

                onComplete(trimmed);

            } catch (e) {
                console.error("Audio trim error:", e);
                onComplete(file);
            }
        };

        process();

    }, [file]);

    return null; // UIなし
}